import axios from 'axios';
import { useMutation } from 'react-query';
import Cookies from 'js-cookie';
import { useQueryJobs } from './useQueryJobs';
import { useSnackbar } from 'hooks/UseSnackbar';
import { useTranslation } from 'react-i18next';

export const useMutationJob = setOpen => {
    const toast = useSnackbar();
    const [t] = useTranslation();

    const { refetch } = useQueryJobs({ enabled: false });
    const mutation = useMutation({
        mutationFn: async obj => {
            await axios.put(
                process.env.REACT_APP_SERVER + 'api/quota/job',
                obj,
                {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization:
                            'bearer ' +
                            (Cookies.get('auth-token')
                                ? Cookies.get('auth-token')
                                : '')
                    }
                }
            );
        },
        onSuccess: () => {
            toast.success(t('QUOTAS.jobUpdated'));
        },
        onError: () => {
            toast.error(t('QUOTAS.jobUpdatedError'));
        },
        onSettled: () => {
            setOpen(false);
            refetch();
        }
    });

    return mutation;
};
